import React from 'react';
import { Skeleton } from '../ui';

const VoiceDemoSkeleton: React.FC = () => (
  <div className="py-6">
    {/* Page header skeleton */}
    <div className="au-page-header">
      <Skeleton variant="text" width="200px" height="32px" />
      <Skeleton variant="text" width="360px" height="20px" />
    </div>

    {/* User selector card skeleton */}
    <div className="au-card p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <Skeleton variant="text" width="140px" height="22px" />
        <div className="flex items-center gap-3">
          <Skeleton variant="text" width="60px" height="16px" />
          <Skeleton variant="rounded" width="100px" height="32px" />
        </div>
      </div>
      <div className="flex items-center gap-4">
        <Skeleton variant="rounded" width="320px" height="42px" />
      </div>
    </div>

    {/* Main content grid skeleton */}
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Conversation list skeleton */}
      <div className="au-card p-6">
        <div className="flex items-center justify-between mb-4">
          <Skeleton variant="text" width="140px" height="22px" />
        </div>
        <div className="space-y-3">
          <div className="flex items-center gap-3 py-3">
            <Skeleton variant="rounded" width="40px" height="40px" />
            <div className="flex-1 space-y-1.5">
              <Skeleton variant="text" width="140px" height="16px" />
              <Skeleton variant="text" width="180px" height="14px" />
            </div>
          </div>
          <div className="border-t border-au-divider pt-3">
            <Skeleton variant="text" width="120px" height="20px" />
            <Skeleton variant="text" width="100%" height="14px" className="mt-2" />
            <Skeleton variant="text" width="80%" height="14px" className="mt-1" />
          </div>
        </div>
      </div>

      {/* Voice panel skeleton */}
      <div className="lg:col-span-2 au-card p-6">
        {/* Controls skeleton */}
        <div className="flex items-center gap-3 pb-4 mb-4 border-b border-au-divider">
          <Skeleton variant="circular" width="32px" height="32px" />
          <div className="space-y-1">
            <Skeleton variant="text" width="100px" height="14px" />
            <Skeleton variant="text" width="80px" height="12px" />
          </div>
          <div className="w-px h-8 bg-au-divider mx-1" />
          <Skeleton variant="rounded" width="100px" height="32px" />
          <Skeleton variant="rounded" width="70px" height="32px" />
          <div className="ml-auto">
            <Skeleton variant="rounded" width="110px" height="24px" />
          </div>
        </div>
        {/* Conversation panel skeleton */}
        <div className="flex items-center justify-between pb-3 mb-3 border-b border-au-divider">
          <Skeleton variant="text" width="130px" height="22px" />
          <Skeleton variant="text" width="80px" height="14px" />
        </div>
        <Skeleton variant="rounded" height="460px" />
      </div>
    </div>
  </div>
);

export default VoiceDemoSkeleton;
